import remotesConfig from 'remotesConfig'
import injectWindowVariables from '@ve/module-federation/injectWindowVariables'
import injectScripts from '@ve/module-federation/injectScripts'
import { initializeHttpInterceptors } from './services/httpHelper'
import { runtimeConfig } from './config/runtimeConfig'

initializeHttpInterceptors()
if (runtimeConfig.maintenance.enabled) {
  injectWindowVariables(remotesConfig)
  import('./bootstrap')
} else {
  injectWindowVariables(remotesConfig)
  injectScripts(remotesConfig)
  import('./bootstrap')
}
export {}
